import { wmsHttp, bigDataWhereHouseHttp, bigDataHttp } from '@/utils/http/index.js'

/**
 * 根据字典编码获取其下所有的数据字典-仓库类型
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/13064
 */
export function getEntrepotType(data) {
	return wmsHttp.post('/warehouse_foundation/dictionary/get_by_code', data)
}

/**
 * 货主寻仓---列表查询
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/12746
 */

export function getEntrepotInfo(data, query) {
	return wmsHttp.post(
		'/warehouse_foundation/warehouse_source/consignor_platform/page',
		data,
		{
			params: query
		}
	)
}

/**
 * 货主寻仓---货主端分页云仓信息详情
 *https://yapi.ops.yunlizhi.cn/project/388/interface/api/12748
 */

export function getEntrepotDetails(data) {
	return wmsHttp.post(
		'/warehouse_foundation/warehouse_source/consignor_platform/detail',
		data
	)
}

/**
 * 货主寻仓 --- 查询下一个仓
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/15733
 */
export function getEntrepotNext(data) {
	return wmsHttp.post(
		'/warehouse_foundation/warehouse/consignor_platform/next',
		data
	)
}

/**
 * 货主寻仓---中心点周边POI查询
 *https://yapi.ops.yunlizhi.cn/project/286/interface/api/12988
 */

export function aroundPoi(data) {
	return bigDataWhereHouseHttp.post(
		`proxy/inp/gaodePoiAround?timestamp=${localStorage.timestamp}`,
		data,
		{
			bigData: true,
		}
	)
}

/**
 * 按地域统计仓库
 * https://yapi.ops.yunlizhi.cn/project/286/interface/api/15609
 * /wms/warehouse/area/statics
 */
export function getAreaStatics(data) {
	return bigDataHttp.post('/wms/warehouse/area/statics', data)
}

/**
 * 按地域查询仓库
 * https://yapi.ops.yunlizhi.cn/project/286/interface/api/15611
 * /wms/warehouse/area/statics
 */
export function getAreaList(data) {
	return bigDataHttp.post('/wms/warehouse/area/list', data)
}
